export default { sha: '1e7802e15eb0c4bad6d8e0ef42e4be90dacd1d12', buildNumber: 'undefined' }
